import { supabase } from "../supabaseClient";

export const signIn = async (userdata) => {
  const { error } = await supabase.auth.signUp({ email: userdata.email, password: userdata.password, options: { data: { name: userdata.name, surname: userdata.surname } } });
  return error ? { status: "error", message: error.message } : { status: "success", message: "Konto zostało utworzone. Sprawdź e-mail, aby je potwierdzić." };
};
export const logIn = async (email, password) => {
  const { data, error } = await supabase.auth.signInWithPassword({ email, password });
  if (error) return { status: "error", message: error.message };
  localStorage.setItem("token", data.session.access_token);
  localStorage.setItem("tokenExpiration", String(data.session.expires_at * 1000));
  return getUser();
};
export const getUser = async () => {
  const { data: auth, error: authError } = await supabase.auth.getUser();
  if (authError || !auth.user) return { status: "error", message: (authError && authError.message) || "Brak autoryzacji" };
  // maybeSingle, bo konto mogło powstać przed migracją 001 (wtedy trigger nie
  // zdążył utworzyć profilu) — brak wiersza nie może blokować logowania.
  const { data: profile } = await supabase.from("profiles").select("name").eq("id", auth.user.id).maybeSingle();
  const name = (profile && profile.name) || (auth.user.user_metadata && auth.user.user_metadata.name) || auth.user.email;
  return { status: "success", message: `Witaj, ${name}`, userData: { _id: auth.user.id, name } };
};
